/* eslint-disable no-empty-pattern */
import React, { useEffect } from "react";

function ErrorModal({ onClose, message, title }) {
    useEffect(() => {
        document.body.classList.add("backdrop-init");

        return () => {
            document.body.classList.remove("backdrop-init");
        };
    }, []);

    let ErrorIcon =
        '<svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_720_52122)"> <path d="M54.1148 64.5001H12.8795C7.43199 64.5001 2.97656 60.0446 2.97656 54.5971V13.3798C2.97656 7.93224 7.43199 3.47681 12.8795 3.47681H54.0968C59.5443 3.47681 63.9998 7.93224 63.9998 13.3798V54.5971C64.0178 60.0446 59.5624 64.5001 54.1148 64.5001Z" fill="#FFDBDB"/> <path d="M51.1202 61.5233H9.90296C4.45543 61.5233 0 57.0691 0 51.6232V10.4001C0 4.95412 4.45543 0.5 9.90296 0.5H51.1202C56.5678 0.5 61.0232 4.95412 61.0232 10.4001V51.6052C61.0412 57.0691 56.5858 61.5233 51.1202 61.5233Z" fill="#F7685B"/> <path d="M32.3343 19.7355C32.3343 18.7295 31.5188 17.9141 30.5128 17.9141C29.5069 17.9141 28.6914 18.7295 28.6914 19.7355V34.8036C28.6914 35.8095 29.5069 36.625 30.5128 36.625C31.5188 36.625 32.3343 35.8095 32.3343 34.8036V19.7355Z" fill="white"/> <rect x="28.6914" y="40.4712" width="3.64285" height="3.63824" rx="1.81912" fill="white"/> </g> <defs> <clipPath id="clip0_720_52122"> <rect width="64" height="64" fill="white" transform="translate(0 0.5)"/> </clipPath> </defs> </svg>';
    return (
        <div className="modal">
            <div className="modal-sendMoney small-modal modal-backdrop fadeIn animated">
                <div className="modal-content kudaFadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center">
                            {title || "An error occurred"}
                        </h4>
                        <div
                            className="kuda-modal-illustration"
                            dangerouslySetInnerHTML={{ __html: ErrorIcon }}
                        ></div>
                        <div className="message-response error-message withdrawal-response">
                            <p className="color-black">
                                {message ||
                                    "Sorry! Something went wrong and we'll need you to retry your request."}
                            </p>
                        </div>
                        <div className="flex justify-center mt-5 inactivity-buttons ">
                            <div className="addAction kuda-cta kuda-cta-md" onClick={onClose}>
                                Try Again
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ErrorModal;
